<template>
	<bw-table aria-label="data-table" :headers="headers" :items="invites">
		<template v-slot:item.name="{ item: invite }">
			<div
					class="font-weight-bold text-subtitle-2 primary--text text--darken-4"
					style="flex-wrap: nowrap !important;"
			>
				{{ invite.name }}
			</div>
			<div class="text-caption primary--text text--darken-2">
				{{ invite.partnerName }}
			</div>
		</template>
		<template v-slot:item.otherInvitees="{ item: invite }">
			<invite-avatars
					:avatarSize="avatarSize"
					:invite="invite"
					:maxAvatars="10"
			></invite-avatars>
		</template>
		<!-- keep the slot -->
		<!-- TODO: Add color to status -->
		<template v-slot:item.statusName="{ item: invite }">
			<span class="text-no-wrap">{{ invite.statusName }}</span>
		</template>
		<template v-slot:item.percent="{ item: invite }">
			<v-progress-circular
					color="success"
					:rotate="-90"
					:size="38"
					:value="27"
					:width="3"
			>
				<span class="font-weight-bold" style="font-size: 0.6875rem;">
					27%
				</span>
			</v-progress-circular>
		</template>
		<template v-slot:item.actions="{ item: invite }">
			<div class="d-flex">
				<v-btn
						v-if="invite.statusCode === 'invited'"
						color="accent"
						depressed
						fab
						:href="viewInvite(invite)"
						small
				>
					<v-icon small>mdi-store-plus-outline</v-icon>
				</v-btn>
				<template v-else-if="invite.statusCode === 'declined'">
					<div class="d-flex justify-center" style="width: 28px;">
						<v-icon color="grey--text" small style="transform: rotate(-45deg);">
							mdi-plus-thick
						</v-icon>
					</div>
				</template>
				<template v-else>
					<div class="d-flex justify-center" style="width: 28px;">
						<v-icon color="success" small>mdi-check-bold</v-icon>
					</div>
				</template>
				<v-divider
						class="mx-2 my-1"
						vertical
				></v-divider>
				<v-btn
						color="secondary"
						depressed
						:disabled="invite.statusCode === 'invited'"
						fab
						:href="viewDetails(invite)"
						small
				>
					<v-icon small>mdi-card-account-details-outline</v-icon>
				</v-btn>
			</div>
		</template>
	</bw-table>
</template>

<script>
export default {
	name: 'ListInvites',
	props: {
		invitesData: {
			type: Array,
			default: () => []
		},
		statuses: {
			type: Array,
			default: () => []
		},
		venue: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			// From here or passed from blade file to props
			headers: [
				{
					align: 'start',
					filterable: false,
					text: 'ID',
					value: 'id',
					width: '1%'
				},
				{
					align: 'start',
					mandatory: true,
					text: 'Pass/Partner',
					value: 'name'
				},
				{
					align: 'start',
					selected: true,
					sortable: false,
					text: 'Invitees',
					value: 'otherInvitees'
				},
				{
					align: 'start',
					filterOn: 'statusName',
					selected: true,
					text: 'Status',
					value: 'statusName',
					width: 'auto'
				},
				// {
				// 	align: 'center',
				// 	selected: true,
				// 	sortable: false,
				// 	text: 'Completed',
				// 	value: 'percent',
				// 	width: '1%'
				// },
				{
					align: 'start',
					mandatory: true,
					sortable: false,
					text: 'Actions',
					value: 'actions',
					width: '1%'
				}
			],
			invites: this.invitesData
		};
	},
	computed: {
		avatarSize() {
			if(this.$vuetify.breakpoint.xsOnly) return 36;
			if(this.$vuetify.breakpoint.smOnly) return 40;
			if(this.$vuetify.breakpoint.mdOnly) return 44;
			return 48;
		}
	},
	created() {
	},
	methods: {
		viewInvite(invite) {
			return `/merchant-portal/${this.venue.id}/invites/view/landing/${invite.id}`;
		},
		viewDetails(invite) {
			return `/merchant-portal/${this.venue.id}/invites/view/invite/${invite.id}`;
		}
	}
};
</script>

<style lang="scss" scoped></style>
